var map = {
	"./1.jpg": 54981,
	"./IMG_0670.JPG": 22866,
	"./IMG_0671.JPG": 11919,
	"./IMG_0672.JPG": 83137,
	"./IMG_0673.JPG": 61214,
	"./IMG_0674.JPG": 63962,
	"./IMG_0675.JPG": 25907,
	"./IMG_0676.JPG": 96301,
	"./IMG_0677.JPG": 7550,
	"./IMG_0678.JPG": 26921,
	"./IMG_0679.JPG": 5371,
	"./IMG_0680.JPG": 25329
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 78798;